<template>
  <v-menu
    v-model="_isMenuDisplayed"
    :position-x="menuCoordinates.x"
    :position-y="menuCoordinates.y"
    offset-y
    max-width="200"
    class="rounded-menu"
  >
    <v-list>
      <!-- Title -->
      <v-subheader>
        Select a block to add
      </v-subheader>

      <!-- Node list -->
      <v-list-item
        v-for="(node, index) in typeOfNodes"
        :key="index"
        @click="ADD_NODE_TO_DIAGRAM({node, position: menuCoordinates})"
      >
        <!-- Icon -->
        <v-list-item-avatar>
          <v-icon
            color="primary"
            v-text="node.icon"
          />
        </v-list-item-avatar>

        <v-list-item-content>
          <!-- Name -->
          <v-list-item-title class="black--text" v-text="node.name" />

          <!-- Description -->
          <v-list-item-subtitle style="white-space: normal" v-text="node.description" />
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'

  export default {
    name: 'FloatingDiagramMenu',
    data: () => ({
      positionX: null,
      positionY: null,
      selectedItem: null
    }),
    computed: {
      ...mapState([ 'isMenuDisplayed', 'menuCoordinates' ]),
      _isMenuDisplayed: {
        get () {
          return this.isMenuDisplayed
        },
        set (value) {
          this.SET_IS_MENU_DISPLAYED(value)
        }
      },
      typeOfNodes () {
        return [
          { name: 'Split', description: 'Split the funds.', icon: 'mdi-call-split' },
          { name: 'Send', description: 'Send the funds to an address.', icon: 'mdi-wallet-outline' }
        ]
      }
    },
    methods: {
      ...mapMutations([ 'SET_IS_MENU_DISPLAYED', 'ADD_NODE_TO_DIAGRAM' ]),
    },
  }
</script>

<style scoped>
   .v-menu__content {
     border-radius: 12px;
   }
</style>
